export enum ITemplateErrors {
	NON_UNIQUE = 'NON_UNIQUE',
}
